import { createEvent, restore, sample } from 'effector'
import { TaskType, TasksTypesResponse, DisableTaskTypeRequest } from './types'
import { fx } from '../../../../../libs'

export const tasksTypesListMounted = createEvent()

export const disableTaskTypeMounted = createEvent<DisableTaskTypeRequest>()

export const getTasksTypes = fx<void, TasksTypesResponse>({
  method: 'GET',
  url: `/promo/golden_may/task`,
})

export const disableTaskType = fx<DisableTaskTypeRequest, void>({
  method: 'PUT',
  url: `/promo/golden_may/task/`,
})

export const $tasksTypes = restore<TaskType[]>(
  getTasksTypes.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfTasksTypes = restore(
  getTasksTypes.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: tasksTypesListMounted,
  target: getTasksTypes,
})

sample({
  // @ts-ignore
  clock: disableTaskTypeMounted,
  fn: ({ id }) => {
    return {
      url: `/promo/golden_may/task/${id}`,
    }
  },
  target: disableTaskType,
})

sample({
  // @ts-ignore
  clock: disableTaskType.doneData,
  target: tasksTypesListMounted,
})
